(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-category-filter')) {
    class ShopCategoryFilter extends HTMLElement {
      connectedCallback() {
        try {
          const json = this.querySelector('[data-product-types]');
          this.types = JSON.parse(json ? json.textContent : '{}');
        } catch (error) {
          this.types = {};
        }

        this.pills = Array.from(this.querySelectorAll('.shop-categories__pill'));
        this.pills.forEach((pill) => {
          pill.addEventListener('click', () => this.select(pill.dataset.category, true));
        });

        const fromUrl = new URL(window.location.href).searchParams.get('category') || '';
        const known = this.pills.some((pill) => pill.dataset.category === fromUrl && !pill.disabled);
        const apply = () => this.select(known ? fromUrl : '', false);

        // The grid sits below this section, so wait until it has been parsed.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', apply, { once: true });
        } else {
          apply();
        }
      }

      select(category, updateUrl) {
        const hasAllPill = this.pills.some((pill) => pill.dataset.category === '');

        // Clicking the active category again goes back to "all" when there is no "All" pill.
        if (updateUrl && !hasAllPill && category && category === this.current) category = '';
        this.current = category;

        this.pills.forEach((pill) => {
          pill.setAttribute('aria-pressed', String(pill.dataset.category === category));
        });

        document.querySelectorAll(this.dataset.gridSelector).forEach((item) => {
          const type = this.types[item.dataset.productId] || '';
          item.hidden = Boolean(category) && type !== category;
        });

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (category) url.searchParams.set('category', category);
          else url.searchParams.delete('category');
          window.history.replaceState(window.history.state, '', url);
        }
      }
    }

    customElements.define('shop-category-filter', ShopCategoryFilter);
  }

  } catch(e) { console.error(e); }
})();
})();
